const doc = [({"zh_tw":({"adminConstantDefaultSortBy":({"lowestPrice":"價格（低到高）", "recommended":"最推薦"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;